import { render, staticRenderFns } from "./Ipad.vue?vue&type=template&id=1db52b1e&scoped=true"
import script from "./Ipad.vue?vue&type=script&lang=js"
export * from "./Ipad.vue?vue&type=script&lang=js"
import style0 from "./Ipad.vue?vue&type=style&index=0&id=1db52b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db52b1e",
  null
  
)

export default component.exports